<template>
	<div style="background-color: #f2f2f2; height: 100vh">
		<div class="w_1200">
			<div style="height: 1px"></div>
			<div class="box_bg">
				<div class="flex">
					<img class="img_tx" :src="avatar" alt="" />
					<div style="margin-left: 20px">
						<div style="color: #4679f0" class="f18">{{nickname}}</div>
						<div class="f16" style="margin-top: 20px">{{email}}</div>
					</div>
				</div>
				<div style="margin-top: 20px">
					<el-tabs v-model="activeName">
						<el-tab-pane :label="$t('my.tab_need')" name="first">
							<div class="flex_js" style="
                  border-bottom: 1px solid #f2f2f2;
                  padding-bottom: 15px;
                  margin-bottom: 15px;
                " v-for="(item,index) in history_list" :key="index">
								<div class="flex">
									<img style="width: 50px; height: 50px; border-radius: 10px" :src="item.thumb"
										alt="" />
									<div style="margin-left: 20px">
										<div class="f14">{{item.name}}</div>
										<div class="f12" style="color: red; margin-top: 5px">
											${{item.price}}
										</div>
									</div>
								</div>
								<el-button round icon="el-icon-star-off" size="mini" style="padding: 5px"
									@click="closeHistory(item.id)">{{$t('my.need_btn_cancel')}}</el-button>
							</div>
						</el-tab-pane>
						<el-tab-pane :label="$t('my.tab_history')" name="second">
							<div class="flex_js" style="
                  border-bottom: 1px solid #f2f2f2;
                  padding-bottom: 15px;
                  margin-bottom: 15px;
                " v-for="(item,index) in order_list" :key="index">
								<div class="flex">
									<img style="width: 50px; height: 50px; border-radius: 10px" :src="item.thumb"
										alt="" />
									<div style="margin-left: 20px">
										<div class="f14">{{item.name}}</div>
										<div class="f12" style="color: red; margin-top: 5px">
											${{item.price}}
										</div>
									</div>
								</div>
								<el-button round icon="el-icon-star-off" size="mini" style="padding: 5px"
									@click="closeOrder(item.id)">{{$t('my.history_btn_cancel')}}</el-button>
							</div>
						</el-tab-pane>
						<div class="flex_jc" v-if="activeName=='first'">
							<el-pagination background layout="total, sizes, prev, pager, next, jumper"
								@size-change="historySizeChange" @current-change="historyCurrentChange"
								:current-page="history_page_data.page" :total="history_page_data.total"
								:page-size="history_page_data.limit">
							</el-pagination>
						</div>
						<div class="flex_jc" v-else>
							<el-pagination background layout="total, sizes, prev, pager, next, jumper"
								@size-change="orderSizeChange" @current-change="orderCurrentChange"
								:current-page="order_page_data.page" :total="order_page_data.total"
								:page-size="order_page_data.limit">
							</el-pagination>
						</div>
					</el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getHistory,
		getOrder,
		cancelHistory,
		cancelOrder
	} from '@/api/my'
	export default {
		name: "userPage",
		data() {
			return {
				nickname: '',
				email: '',
				avatar: 'http://www.fzxp.cc/upload/img/avatar.png',
				activeName: 'first',
				history_page_data: {
					limit: 10,
					page: 1,
					total: 0,
				},
				order_page_data: {
					limit: 10,
					page: 1,
					total: 0,
				},
				history_list: [],
				order_list: []
			}
		},
		created() {
			var info = JSON.parse(localStorage.getItem('user'))
			this.nickname = info.nickname
			this.email = info.email
			this.avatar = info.avatar
			this.getHistoryList()
			this.getOrderList()
		},
		methods: {
			getHistoryList() {
				getHistory(this.history_page_data).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.history_list = res.data.rows
						this.history_page_data.total = res.data.total
					}
				})
			},
			getOrderList() {
				getOrder(this.order_page_data).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.order_list = res.data.rows
						this.order_page_data.total = res.data.total
					}
				})
			},
			closeHistory(id) {
				this.$modal.confirm(this.$t('my.cancel_confirm_history')).then(() => {
					return cancelHistory({
						id: id
					})
				}).then(() => {
					this.getHistoryList()
				}).catch(() => {
					console.log('cancel')
				})
			},
			closeOrder(id) {
				this.$modal.confirm(this.$t('my.cancel_confirm_history')).then(() => {
					return cancelOrder({
						id: id
					})
				}).then(() => {
					this.getOrderList()
				}).catch(() => {
					console.log('cancel')
				})

			},
			historySizeChange(e) {
				console.log(e)
				this.history_page_data.limit = e
				this.getHistoryList()
			},
			historyCurrentChange(e) {
				console.log(e)
				this.history_page_data.page = e
				this.getHistoryList()
			},
			orderSizeChange(e) {
				console.log(e)
				this.order_page_data.limit = e
				this.getOrderList()
			},
			orderCurrentChange(e) {
				console.log(e)
				this.order_page_data.page = e
				this.getOrderList()
			}
		}
	};
</script>

<style>
	.box_bg {
		margin: 20px;
		padding: 50px;
		background-color: #fff;
	}

	.img_tx {
		width: 100px;
		height: 100px;
		border-radius: 10px;
	}

	@media (max-width: 768px) {
		.box_bg {
			margin: 10px;
			padding: 15px;
			background-color: #fff;
		}

		.img_tx {
			width: 100px;
			height: 100px;
			border-radius: 10px;
		}
	}
</style>